// Collection / search grid extras. Classic script, no dependency.
// Loaded by sections/main-collection-product-grid.liquid and sections/main-search.liquid.
//  1. "VUE − +": grid density (.rd-view buttons -> data-rd-zoom on .rd-grid-section), kept for the session.
//  2. Filter panel (snippets/facets.liquid + facets-panel.liquid): from 990px "FILTRER" / "MASQUER" opens the
//     sidebar next to the grid natively (no focus trap / scroll lock: those suit the mobile sheet only);
//     the accordions open natively; Escape closes the sidebar; a selected sort can be unselected (sort
//     chips); "Supprimer" is disabled while nothing is filtered.
//  3. Price slider: two range inputs drive the named price inputs read by facets.js.
//  4. Sub-collection chips: the current chip is scrolled into view; previous / next buttons when they overflow.
//  5. Infinite scroll (setting "Pagination"): the next page is appended when the end of the grid comes near;
//     the page links stay in the markup (no-JS, search engines) and come back if a request fails.
//  6. Card photo arrows (search): previous / next photo of the product.
//  7. Quick add popups (card bag): a popup opened from the header search layer leaves the layer open (and
//     its scroll lock / focus trap); popup copies left behind by filtering / sorting are removed; Tab stays in
//     an open popup or filter sheet (visible elements only).
//  8. Keyboard focus: a focused card comes fully into view; a focused chip scrolls its row.
//  9. Page scroll: direction (phones / tablets: chips band, search results bar), back to top button, phone /
//     tablet collection title row and toolbar pinned to the end of the page, height of the desktop filter sidebar.
// Also loaded on every page by snippets/header-search-discover.liquid (search layer cards).
// Everything is delegated or re-run on facets.js renders and on theme editor section reloads.
(() => {
  if (window.rdCollectionGrid) return;
  window.rdCollectionGrid = true;

  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const ZOOM_KEY = 'rd-grid-zoom';

  /* 1. density -------------------------------------------------------------------------- */
  const readZoom = () => {
    try {
      return sessionStorage.getItem(ZOOM_KEY) === '1';
    } catch (e) {
      return false;
    }
  };
  const applyZoom = (zoomed) => {
    document.querySelectorAll('.rd-grid-section').forEach((section) => {
      if (!section.querySelector('.rd-view')) return;
      section.toggleAttribute('data-rd-zoom', zoomed);
      section.querySelectorAll('.rd-view__button').forEach((button) => {
        button.disabled = (button.dataset.rdZoom === 'in') === zoomed;
      });
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.rd-view__button');
    if (!button || button.disabled) return;
    const zoomed = button.dataset.rdZoom === 'in';
    try {
      sessionStorage.setItem(ZOOM_KEY, zoomed ? '1' : '0');
    } catch (e) {}
    applyZoom(zoomed);
    const other = button.parentElement.querySelector('.rd-view__button:not(:disabled)');
    if (other) other.focus();
  });

  /* 2. filter panel ----------------------------------------------------------------------- */
  const sidebarOf = (summary) => {
    const section = summary.closest('.rd-grid-section');
    return section ? section.querySelector('.rd-layout__side') : null;
  };
  // The theme's <menu-drawer> listens to every <summary> click inside it: keep it away from the
  // accordions (always) and from the sidebar opener on desktop; the native <details> toggle does the rest.
  document.addEventListener(
    'click',
    (event) => {
      const summary = event.target.closest('summary');
      if (!summary) return;
      if (summary.classList.contains('rd-facet__summary')) {
        event.stopPropagation();
      } else if (summary.classList.contains('mobile-facets__open-wrapper') && DESKTOP.matches && sidebarOf(summary)) {
        event.stopPropagation();
      }
    },
    true
  );
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      const summary = details.querySelector(':scope > summary');
      if (details.classList.contains('rd-facet')) {
        if (summary) summary.setAttribute('aria-expanded', details.open);
      } else if (details.classList.contains('mobile-facets__disclosure') && summary && DESKTOP.matches && sidebarOf(summary)) {
        summary.setAttribute('aria-expanded', details.open);
        const section = summary.closest('.rd-grid-section');
        if (section) section.toggleAttribute('data-rd-panel', details.open);
        if (details.open) sizeSidebars();
      }
    },
    true
  );
  // "FILTRER" controls the sidebar from 990px and the sheet below
  const syncOpeners = () => {
    document.querySelectorAll('.facets-container-drawer .mobile-facets__open-wrapper').forEach((summary) => {
      const side = sidebarOf(summary);
      const sheet = summary.parentElement.querySelector('form.mobile-facets');
      const target = DESKTOP.matches && side && side.id ? side : sheet;
      if (target && target.id) summary.setAttribute('aria-controls', target.id);
    });
  };
  // Crossing 990px with the panel open (sidebar <-> sheet): close it, so the next press opens the right one
  const onBreakpoint = () => {
    document.querySelectorAll('.facets-container-drawer .mobile-facets__disclosure[open]').forEach((details) => {
      const drawer = details.closest('menu-drawer');
      const summary = details.querySelector(':scope > summary');
      // the sheet was opened by the theme's menu drawer: let it release the scroll lock and the focus trap
      if (details.classList.contains('menu-opening') && drawer && typeof drawer.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer(new Event('rd-breakpoint'), false);
      }
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.rd-grid-section[data-rd-panel]').forEach((section) => section.removeAttribute('data-rd-panel'));
    syncOpeners();
  };
  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', onBreakpoint);
  else if (DESKTOP.addListener) DESKTOP.addListener(onBreakpoint);
  // Escape in the desktop sidebar closes it
  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    const side = event.target.closest && event.target.closest('.rd-layout__side');
    if (!side) return;
    const section = side.closest('.rd-grid-section');
    const summary = section && section.querySelector('.mobile-facets__open-wrapper');
    if (summary && summary.parentElement.open) {
      summary.click();
      summary.focus();
    }
  });
  // selected sort chip: a second click unselects it (back to the default sort)
  document.addEventListener(
    'pointerdown',
    (event) => {
      const option = event.target.closest('.rd-facet__option');
      if (!option) return;
      const radio = option.querySelector('.rd-facet__radio');
      if (radio) radio.dataset.rdWasChecked = radio.checked ? '1' : '';
    },
    true
  );
  document.addEventListener('click', (event) => {
    const radio = event.target;
    if (!radio.classList || !radio.classList.contains('rd-facet__radio')) return;
    if (radio.dataset.rdWasChecked === '1') {
      radio.checked = false;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
    }
    radio.dataset.rdWasChecked = '';
  });
  // "Supprimer" only works when something is filtered
  const syncClear = () => {
    document.querySelectorAll('.mobile-facets__clear').forEach((link) => {
      const form = link.closest('form');
      const active =
        !!form && !!form.querySelector('input.mobile-facets__checkbox:checked, .rd-range[data-rd-active]');
      if (active) {
        link.removeAttribute('aria-disabled');
        link.removeAttribute('tabindex');
        if (!link.hasAttribute('href') && link.dataset.rdHref) link.setAttribute('href', link.dataset.rdHref);
      } else {
        link.setAttribute('aria-disabled', 'true');
        link.setAttribute('tabindex', '-1');
        // no href while disabled: the theme's focus trap of the sheet would take it as its last stop (it never gets
        // the focus, so Tab went on to the page behind the sheet)
        if (link.hasAttribute('href')) {
          link.dataset.rdHref = link.getAttribute('href');
          link.removeAttribute('href');
        }
      }
    });
  };
  document.addEventListener('change', (event) => {
    if (event.target.classList && event.target.classList.contains('mobile-facets__checkbox')) syncClear();
  });

  /* 3. price slider ----------------------------------------------------------------------- */
  const money = (range, value) => {
    const zero = range.dataset.rdMoney || '0';
    return zero.replace(/0(?![\d])/, String(value));
  };
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!input.classList || !input.classList.contains('rd-range__input')) return;
    const range = input.closest('.rd-range');
    const lo = range.querySelector('.rd-range__input--min');
    const hi = range.querySelector('.rd-range__input--max');
    const max = Number(hi.max) || 1;
    if (Number(lo.value) > Number(hi.value)) {
      if (input === lo) lo.value = hi.value;
      else hi.value = lo.value;
    }
    const [loValue, hiValue] = range.querySelectorAll('.rd-range__value');
    const a = Number(lo.value);
    const b = Number(hi.value);
    loValue.value = a > 0 ? String(a) : '';
    hiValue.value = b < max ? String(b) : '';
    range.style.setProperty('--rd-lo', String((a * 100) / max));
    range.style.setProperty('--rd-hi', String((b * 100) / max));
    range.querySelector('.rd-range__label--min').textContent = money(range, a);
    range.querySelector('.rd-range__label--max').textContent = money(range, b);
    range.toggleAttribute('data-rd-active', a > 0 || b < max);
    syncClear();
  });

  /* 4. chips ----------------------------------------------------------------------------- */
  const updateChipArrows = (list) => {
    const nav = list.closest('.rd-chips');
    if (!nav) return;
    const overflow = list.scrollWidth > list.clientWidth + 1;
    const prev = nav.querySelector('.rd-chips__arrow--prev');
    const next = nav.querySelector('.rd-chips__arrow--next');
    nav.toggleAttribute('data-rd-overflow', overflow);
    if (prev) prev.hidden = !overflow || list.scrollLeft <= 0;
    if (next) next.hidden = !overflow || list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
  };
  const initChips = () => {
    document.querySelectorAll('.rd-chips__list').forEach((list) => {
      const active = list.querySelector('.rd-chips__link--active');
      if (active && list.scrollWidth > list.clientWidth) {
        const left = active.offsetLeft - list.offsetLeft;
        if (left + active.offsetWidth > list.clientWidth) list.scrollLeft = left - 16;
      }
      if (!list.dataset.rdWatched) {
        list.dataset.rdWatched = '1';
        list.addEventListener('scroll', () => updateChipArrows(list), { passive: true });
      }
      updateChipArrows(list);
    });
  };
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('.rd-chips__arrow');
    if (!arrow) return;
    const list = arrow.closest('.rd-chips').querySelector('.rd-chips__list');
    list.scrollBy({ left: Number(arrow.dataset.rdChipsStep) * list.clientWidth * 0.8, behavior: 'smooth' });
  });
  window.addEventListener('resize', () => document.querySelectorAll('.rd-chips__list').forEach(updateChipArrows));

  /* 5. infinite scroll -------------------------------------------------------------------- */
  const listOf = (root) => {
    const grid = root.getElementById ? root.getElementById('product-grid') : root.querySelector('#product-grid');
    if (!grid) return null;
    return grid.matches('ul') ? grid : grid.querySelector('ul.product-grid');
  };
  const loadNext = (sentinel) => {
    if (sentinel.dataset.rdLoading) return;
    sentinel.dataset.rdLoading = '1';
    const list = listOf(document);
    const grid = document.getElementById('product-grid');
    if (!list || !grid) return;
    const url = new URL(sentinel.dataset.rdNext, window.location.href);
    url.searchParams.set('section_id', grid.dataset.id);
    fetch(url.toString())
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextList = listOf(doc);
        if (!nextList) throw new Error('no grid');
        [...nextList.children].forEach((item) => list.appendChild(item));
        const nextSentinel = doc.querySelector('.rd-infinite[data-rd-next]');
        const pagination = doc.querySelector('.pagination-wrapper');
        const currentPagination = sentinel.parentElement.querySelector('.pagination-wrapper');
        if (currentPagination && pagination) currentPagination.replaceWith(pagination);
        if (observer) observer.unobserve(sentinel);
        if (nextSentinel) sentinel.replaceWith(nextSentinel);
        else sentinel.remove();
        watchSentinels();
      })
      .catch(() => {
        const wrapper = sentinel.closest('.rd-infinite-grid');
        if (wrapper) wrapper.classList.remove('rd-infinite-grid');
        sentinel.remove();
      });
  };
  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => entries.forEach((entry) => entry.isIntersecting && loadNext(entry.target)),
          { rootMargin: '0px 0px 800px 0px' }
        )
      : null;
  const watchSentinels = () => {
    document.querySelectorAll('.rd-infinite[data-rd-next]:not([data-rd-watched])').forEach((sentinel) => {
      sentinel.setAttribute('data-rd-watched', '');
      if (observer) observer.observe(sentinel);
      else sentinel.closest('.rd-infinite-grid')?.classList.remove('rd-infinite-grid');
    });
  };

  /* 6. card photo arrows ------------------------------------------------------------------ */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.rd-card-arrows__button');
    if (!button) return;
    event.preventDefault();
    const box = button.closest('.rd-card-arrows');
    const card = box.closest('.card');
    const img = card && card.querySelector('.card__media img');
    const urls = (box.dataset.rdMedia || '').split('|').map((u) => u.trim()).filter(Boolean);
    if (!img || urls.length < 2) return;
    const index = (Number(box.dataset.rdIndex || 0) + Number(button.dataset.rdStep) + urls.length) % urls.length;
    box.dataset.rdIndex = String(index);
    img.removeAttribute('srcset');
    img.src = urls[index];
  });

  /* 7. quick add popups ------------------------------------------------------------------- */
  // The search layer (<details-modal>, secondary.js) closes on any click outside itself, and the popups live
  // at the end of <body>: a click inside a popup opened from the layer must leave the layer open.
  if (window.customElements) {
    customElements.whenDefined('details-modal').then(() => {
      const proto = customElements.get('details-modal').prototype;
      if (proto.rdQuickAddAware || typeof proto.onBodyClick !== 'function') return;
      proto.rdQuickAddAware = true;
      const onBodyClick = proto.onBodyClick;
      proto.onBodyClick = function (event) {
        if (event.target instanceof Element && event.target.closest('quick-add-modal')) return;
        onBodyClick.call(this, event);
      };
    });
  }
  const openLayer = () =>
    [...document.querySelectorAll('details-modal')].find((modal) => modal.querySelector(':scope > details[open]'));
  // The popup's close releases the page scroll lock and the focus trap (shared with the layer) and puts the
  // focus back on its bag: still inside an open layer, give the layer its lock and its trap back.
  // (modalClosed is dispatched on <body> without bubbling: listen in the capture phase)
  document.addEventListener(
    'modalClosed',
    () => {
      const layer = openLayer();
      if (!layer) return;
      setTimeout(() => {
        const details = layer.querySelector(':scope > details[open]');
        if (!details || document.querySelector('quick-add-modal[open]')) return;
        document.body.classList.add('overflow-hidden-sticky');
        const container = details.querySelector('[tabindex="-1"]');
        // (after an add to cart the cart drawer takes over: leave its focus alone)
        const inLayer = () => container && container.contains(document.activeElement);
        if (!inLayer()) return;
        import('@theme/main')
          .then(({ trapFocus }) => {
            if (inLayer() && details.hasAttribute('open')) trapFocus(container, document.activeElement);
          })
          .catch(() => {});
      });
    },
    true
  );
  // Keyboard trap of an open popup: Tab / Shift+Tab cycle through what it SHOWS. The theme's trap takes its first
  // and last elements once, when the popup opens, hidden ones included (the content loads later and variant
  // changes re-render it): the focus could leave for the page behind. The list is taken again on every key press;
  // a radio group is one stop (its checked radio), like the browser. (The search layer's own trap, header part,
  // stays out of the popups; closing a popup still puts the focus back on its bag.)
  // The same goes for the filter sheet of phones / tablets (the theme's menu drawer trap): it covers the page.
  const TABBABLE =
    'a[href], area[href], button, input:not([type="hidden"]), select, textarea, summary, iframe, [contenteditable], [tabindex]';
  // rendered and not hidden (a closed <details> still reports boxes for its content in Chrome: checkVisibility)
  const visible = (element) =>
    typeof element.checkVisibility === 'function'
      ? element.checkVisibility({ visibilityProperty: true, checkVisibilityCSS: true })
      : element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  const shown = (element) =>
    element.tabIndex >= 0 && !element.disabled && !element.closest('[inert]') && visible(element);
  const openSheet = () => {
    const details = document.querySelector('menu-drawer.mobile-facets__wrapper > details.mobile-facets__disclosure[open]');
    const sheet = details && details.querySelector('.mobile-facets__inner');
    return sheet && visible(sheet) ? sheet : null; // from 990px the sidebar (not modal) takes over
  };
  const stops = (popup) => {
    const radios = new Map();
    return [...popup.querySelectorAll(TABBABLE)].filter(shown).filter((element) => {
      if (element.type !== 'radio' || !element.name) return true;
      const group = [...popup.querySelectorAll('input[type="radio"]')].filter((r) => r.name === element.name && shown(r));
      const stop = group.find((r) => r.checked) || group[0];
      if (radios.has(element.name)) return false;
      if (stop !== element) return false;
      radios.set(element.name, element);
      return true;
    });
  };
  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) return;
      const popup = document.querySelector('quick-add-modal[open]') || openSheet();
      if (!popup) return;
      const items = stops(popup);
      if (!items.length) return;
      event.preventDefault();
      event.stopPropagation();
      const active = document.activeElement;
      const focused = active && popup.contains(active) ? active : null;
      let index = focused ? items.indexOf(focused) : -1;
      if (index === -1) {
        // the focus is on the dialog itself, on a hidden element or outside: go on from its place
        const after = focused
          ? items.findIndex((item) => focused.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING)
          : -1;
        if (after === -1) index = event.shiftKey ? items.length : -1;
        else index = event.shiftKey ? after : after - 1;
      }
      const step = event.shiftKey ? -1 : 1;
      items[(index + step + items.length) % items.length].focus();
    },
    true
  );
  // facets.js renders bring new popups (each one moves itself to <body>): keep the newest copy of each popup
  // and the open one, drop the copies whose bag is gone.
  const prunePopups = () => {
    const kept = new Set();
    [...document.querySelectorAll('body > quick-add-modal[id]')].reverse().forEach((modal) => {
      if (modal.hasAttribute('open')) {
        kept.add(modal.id);
        return;
      }
      const opener = document.querySelector(`modal-opener[data-modal="#${CSS.escape(modal.id)}"]`);
      if (!opener || kept.has(modal.id)) modal.remove();
      else kept.add(modal.id);
    });
  };

  /* 8. keyboard focus -------------------------------------------------------------------------- */
  // The browser only scrolls the focused element itself into view: a card (product card, collection tile) whose
  // name gets the focus could keep its photo and its focus ring under the header / the sticky bands. Keyboard
  // focus only (:focus-visible). The page is scrolled VERTICALLY only (the page's scroll-padding + the card's
  // scroll-margin keep the header and the bands clear): a horizontal scroll would cut into a carousel's own smooth
  // scrolling (and its snapping would put it back). Cards in dialogs / drawers / the search layer are left alone.
  // A chip half out of its sideways row scrolls the row (never the page: the band is pinned).
  document.addEventListener('focusin', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    // the search results bar slides away while the page scrolls down: a focus inside it brings it back
    if (target.closest('#main-search-filters')) setScrollDown(false);
    if (!target.matches(':focus-visible')) return;
    const chip = target.closest('.rd-chips__link');
    if (chip) {
      const list = chip.closest('.rd-chips__list');
      if (!list || list.scrollWidth <= list.clientWidth) return;
      const cs = getComputedStyle(list);
      const box = list.getBoundingClientRect();
      const r = chip.getBoundingClientRect();
      const left = box.left + parseFloat(cs.paddingLeft);
      const right = box.right - parseFloat(cs.paddingRight);
      if (r.left < left) list.scrollLeft -= left - r.left;
      else if (r.right > right) list.scrollLeft += r.right - right;
      return;
    }
    const card = target.closest('.card-wrapper');
    if (!card || target.closest('quick-add-modal, .mobile-facets, .rd-sidebar, details-modal, dialog, cart-drawer, .drawer')) return;
    requestAnimationFrame(() => {
      if (document.activeElement !== target) return;
      // both page paddings: the header (top), a floating bar (bottom, e.g. the product page's add to cart bar)
      const cs = getComputedStyle(document.documentElement);
      const top = (parseFloat(cs.scrollPaddingTop) || 0) + (parseFloat(getComputedStyle(card).scrollMarginTop) || 0);
      const bottom = window.innerHeight - (parseFloat(cs.scrollPaddingBottom) || 0);
      const r = card.getBoundingClientRect();
      let dy = 0;
      if (r.top < top) dy = r.top - top;
      else if (r.bottom > bottom) dy = Math.min(r.bottom - bottom, r.top - top);
      if (Math.abs(dy) >= 1) window.scrollBy({ top: dy, left: 0 });
    });
  });

  /* 9. page scroll ------------------------------------------------------------------------------ */
  // - direction (phones / tablets, CSS below 990px): while the page scrolls down the sections get
  //   data-rd-scroll-down (the chips band scrolls away, only the toolbar stays under the header; the search
  //   results bar slides behind the field band, once the results pass under it); scrolling up (8px) or reaching
  //   the top removes it.
  // - back to top button: shown as soon as the page is scrolled, hidden at the very top.
  // - phones / tablets: html[data-rd-scrolled] while the page is not at the very top (the collection title row
  //   collapses); the collection section's sticky area is stretched to the end of the page (--rd-tail), so its
  //   toolbar stays pinned over the links block and the footer.
  // - desktop filter sidebar: as tall as the window below it (its footer 24px above the bottom edge).
  function sizeTails() {
    document.querySelectorAll('.rd-grid-section').forEach((section) => {
      if (DESKTOP.matches || !section.querySelector('#main-collection-filters')) {
        section.style.removeProperty('--rd-tail');
        return;
      }
      // what follows the section down to the end of the page (the tail itself moves nothing: no feedback)
      const tail = parseFloat(section.style.getPropertyValue('--rd-tail')) || 0;
      const end = section.getBoundingClientRect().bottom + window.scrollY - tail;
      const pageEnd = document.body.getBoundingClientRect().bottom + window.scrollY;
      const next = Math.max(0, Math.floor(pageEnd - end));
      if (Math.abs(next - tail) >= 1) section.style.setProperty('--rd-tail', `${next}px`);
    });
  }
  // the search results bar stays put until the results start passing under it (phones: scrollY past 115px,
  // where they start); from there it goes on any scroll down, like the chips band of the collections
  const holdsBar = (section, y) => {
    if (!section.classList.contains('template-search')) return false;
    const results = section.querySelector('#ProductGridContainer');
    return !!results && y <= results.getBoundingClientRect().top + window.scrollY;
  };
  function setScrollDown(down, y = 0) {
    document.querySelectorAll('.rd-grid-section').forEach((section) => {
      if (down === section.hasAttribute('data-rd-scroll-down')) return;
      section.toggleAttribute('data-rd-scroll-down', down && !holdsBar(section, y));
    });
  }
  function sizeSidebars() {
    if (!DESKTOP.matches) return;
    document.querySelectorAll('.rd-grid-section[data-rd-panel] .rd-sidebar').forEach((side) => {
      const stick = parseFloat(getComputedStyle(side).top) || 0;
      // where it is, or its sticky top when the end of the grid pushes it up (no size feedback)
      const top = Math.max(side.getBoundingClientRect().top, stick);
      side.style.setProperty('--rd-side-h', `${Math.max(160, Math.round(window.innerHeight - top))}px`);
    });
  }
  let lastY = Math.max(0, window.scrollY);
  let travel = 0;
  let scrollTicking = false;
  const onScroll = () => {
    scrollTicking = false;
    const y = Math.max(0, window.scrollY);
    const dy = y - lastY;
    lastY = y;
    document.querySelectorAll('.rd-back-to-top').forEach((button) => button.classList.toggle('is-visible', y > 0));
    if (document.querySelector('.rd-grid-section')) document.documentElement.toggleAttribute('data-rd-scrolled', y > 0);
    sizeSidebars();
    if (y <= 0) {
      travel = 0;
      setScrollDown(false);
      return;
    }
    if (!dy) return;
    travel = Math.sign(travel) === Math.sign(dy) ? travel + dy : dy;
    if (travel > 8) setScrollDown(true, y);
    else if (travel < -8) setScrollDown(false);
  };
  window.addEventListener(
    'scroll',
    () => {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(onScroll);
    },
    { passive: true }
  );
  window.addEventListener('resize', () => {
    sizeSidebars();
    sizeTails();
  });
  window.addEventListener('load', sizeTails);
  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', sizeTails);
  // the page height changes (footer accordions, more products, fonts, a section loaded later): the tail follows
  let tailObserver = null;
  const watchTails = () => {
    if (tailObserver || !('ResizeObserver' in window) || !document.querySelector('.rd-grid-section #main-collection-filters')) return;
    tailObserver = new ResizeObserver(() => sizeTails());
    tailObserver.observe(document.body);
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('.rd-back-to-top');
    if (!button) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    // keyboard / screen reader users go on from the top of the page
    const main = document.getElementById('MainContent');
    if (main) main.focus({ preventScroll: true });
  });

  /* init + re-init ------------------------------------------------------------------------- */
  const watched = new WeakSet();
  const init = () => {
    applyZoom(readZoom());
    onScroll();
    sizeTails();
    watchTails();
    syncOpeners();
    initChips();
    watchSentinels();
    syncClear();
    // facets.js replaces the grid and the filters: re-arm what lives inside
    const container = document.getElementById('ProductGridContainer');
    if (container && !watched.has(container) && 'MutationObserver' in window) {
      watched.add(container);
      new MutationObserver(() => {
        watchSentinels();
        syncClear();
        prunePopups();
      }).observe(container, { childList: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
